export default {
      id: "arrow-special-left-black-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-special-left-black",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-special-left-black.svg
// module id = 126
// module chunks = 241 242 243